export default "__VITE_ASSET__DRHi9HxT__"